export default __webpack_public_path__ + "assets/876186.svg";